var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-responsive',{staticClass:"pa-0 ma-0",attrs:{"aspect-ratio":_vm.width / _vm.height,"max-width":_vm.width,"max-height":_vm.height}},[_c('v-container',{staticClass:"grey lighten-3 pa-0",attrs:{"fluid":"","fill-height":""}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('img',_vm._g(_vm._b({staticClass:"white--text align-end px-0 ma-0",attrs:{"width":_vm.width - 1,"height":_vm.height - 1,"contain":"","src":_vm.getImageURLByWidthAndDensity(1),"srcset":_vm.getImageURLByWidthAndDensity(1) +
              ' 1x,' +
              _vm.getImageURLByWidthAndDensity(2) +
              ' 2x,' +
              _vm.getImageURLByWidthAndDensity(3) +
              ' 3x,' +
              _vm.getImageURLByWidthAndDensity(4) +
              ' 4x',"options":{ rootMargin: '1000px' }},on:{"load":function($event){_vm.loading = false},"error":_vm.errorLoadingImage}},'img',attrs,false),on))]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltip))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }